import { MprcMessageBox } from 'components';
import { EnrollmentViewPreChecksResponse } from 'generated/CoreApi_v1';
import React from 'react';
import { useGobackOrLms } from 'views/common/hooks/useGobackOrHome';
import { TrainingAgreementDialog } from '../../TrainingAgreement';

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    enrollmentId: string;
    preChecks: EnrollmentViewPreChecksResponse;
    onReload: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const EnrollmentViewPreChecks: React.FC<IProps> = ({ enrollmentId, preChecks, onReload }) => {
    const goBackOrHome = useGobackOrLms();

    if (preChecks.trainingAgreementPending)
        return <TrainingAgreementDialog
            enrollmentId={enrollmentId}
            onClose={(agree: boolean) => {
                if (agree) onReload();
                else goBackOrHome();
            }}
        />;

    return <MprcMessageBox
        variant="warning"
        fullWidth
        message={preChecks.blockReason ?? ""}
    />;
};
